// import TweenLite from './vendor/TweenLite';
import Preloader from "./preloader"
import Intro from "./intro"
import ProgressBar from "./progress-bar";
import Question from "./question"
import Results from "./results"
import Overlay from "./overlay"
import { qsArray } from "./utilities/selectors"

let Application = function (params) {
	if (Application.prototype._singletonInstance) {
		return Application.prototype._singletonInstance
	}
	Application.prototype._singletonInstance = this

	this.initialize(params)
}

Application.prototype.initialize = function (params) {
	// console.log('Application initalizing ' + params);

	Application.tweenLength = 0.5
	Application.tweenStagger = "-=0.25"

	/**
	 *
	 */
	let self = this
	this.preloader = new Preloader({})
	this.overlay = new Overlay()
	this.intro = new Intro({})
	this.question1 = new Question({ elementId: "question-1" })
	this.question2 = new Question({ elementId: "question-2" })
	this.question3 = new Question({ elementId: "question-3" })
	this.question4 = new Question({ elementId: "question-4" })
	this.question5 = new Question({ elementId: "question-5" })
	this.question6 = new Question({ elementId: "question-6" })
	this.question7 = new Question({ elementId: "question-7" })
	this.question8 = new Question({ elementId: "question-8" })
	this.question9 = new Question({ elementId: "question-9" })
	this.question10 = new Question({ elementId: "question-10" })
	this.question11 = new Question({ elementId: "question-11" })
	this.question12 = new Question({ elementId: "question-12" })
	this.questions = [this.question1, this.question2, this.question3, this.question4, this.question5, this.question6, this.question7, this.question8, this.question9, this.question10, this.question11, this.question12]
	//this.questions = [this.question1, this.question2]
	this.results = new Results({})

	this.progressBar = new ProgressBar();
	this.progressBar.hide();
	this.progressBarSegments = document.querySelectorAll('.progress-bar');

	this.progressBar.onBackButtonClick = function () {
		self.questions[self.currentQuestion - 1].previousClicked();
	};

	// Current screen/state info
	// preloader, intro, question, results
	this.currentState = "preloader"
	this.currentQuestion = 0
	this.totalQuestions = this.questions.length
	// this.totalQuestions = 1; // for testing results faster

	this.progressIndex = 0

	// Scoring info
	// array of html element ids that have data attributes that are used to calculate final results
	this.answers = []


	this.questionScores = {};

	this.matrix = [
		
		{
			id: "mb",
			min: 1,
			max: 10
		},
		{
			id: "cb",
			min: 1,
			max: 10
		},
		{
			id: "t100",
			min: 11,
			max: 24
		},
		{
			id: "t150",
			min: 25,
			max: 40
		},
		{
			id: "t250",
			min: 41,
			max: 56
		},
		{
			id: "t350",
			min: 57,
			max: 70
		},
		{
			id: "t250star",
			min: 71,
			max: 80
		}
	]

	this.preloaderClosed = function () {
		this.intro.open()
		this.currentState = "intro"
		window.resizeFrame()
	}

	this.introClosed = function () {
		this.scrollToTopOfPage()
		this.currentState = "question"
		this.currentQuestion = 1
		this.question1.open()
		window.resizeFrame()
	}

	this.questionClosed = function (direction) {
		if (direction > 0) {
			// next question or results
			this.currentQuestion++
		} else {
			// previous question or intro
			this.currentQuestion--
		}
		this.scrollToTopOfPage()
		if (this.currentQuestion === 0) {
			this.intro.open()
			window.resizeFrame()
		} else if (this.currentQuestion === this.totalQuestions + 1) {
			//show results
			this.results.open()
			this.currentState = "results"
			window.resizeFrame()
		} else {
			this.questions[this.currentQuestion - 1].open()
		}
	}

	this.storeAnswer = function (answerId) {
		this.answers[this.currentQuestion - 1] = answerId
		//console.log('history is ', this.answers);
		// just to help see progress
		var trash = this.calculateResults()
	}

	this.applyScore = function (questionId, score) {
		this.questionScores[questionId] = parseInt(score);
		//console.log('history is ', this.answers);
		// just to help see progress
		var trash = this.calculateResults()
	}

	this.getTotalScore = function () {
		let totalScore = 0;

		for (let key in this.questionScores) {
			if (this.questionScores.hasOwnProperty(key)) {
				totalScore += this.questionScores[key];
			}
		}

		return totalScore;
	}

	this.calculateResults = function () {
		let totalScore = this.getTotalScore();
		

		let sortedScores = [], primaryScores = [], alternativeScores = [];
		this.matrix.forEach(function (obj) {
			if (totalScore >= obj.min && totalScore <= obj.max) {
				primaryScores.push(obj);
			}
		})

		if (primaryScores.length > 1) {
			sortedScores = this.sortByTiebreaker(primaryScores);
		} else {
			this.matrix.forEach(function (obj) {

				if (primaryScores.length == 1) {
					if (primaryScores[0].id == obj.id) {
						return;
					}
				}

				let diffFromMin = Math.abs(obj.min - totalScore);
				let diffFromMax = Math.abs(obj.max - totalScore);

				let diff = Math.min(diffFromMin, diffFromMax);
				obj.diff = diff;
				if (alternativeScores.length == 0) {
					alternativeScores.push(obj);
				} else {
					if (obj.diff < alternativeScores[0].diff) {
						alternativeScores[0] = obj;

						if (alternativeScores.length > 1) {
							alternativeScores.splice(1, alternativeScores.length - 1);
						}
					} else if (obj.diff == alternativeScores[0].diff) {
						alternativeScores.push(obj);
					}
				}
				
				
			})

			if (primaryScores.length == 1) {
				sortedScores.push(primaryScores[0]);

				if (alternativeScores.length > 0) {
					if (alternativeScores.length > 1) {
						alternativeScores = this.sortByTiebreaker(alternativeScores);
						
					} 

					sortedScores.push(alternativeScores[0]);
				}

			} else {
				if (alternativeScores.length > 0) {
					if (alternativeScores.length > 1) {
						alternativeScores = this.sortByTiebreaker(alternativeScores);

					}
					sortedScores.push(...alternativeScores);
				}
			}
		}

		return sortedScores;
	}

	this.sortByTiebreaker = function (scores) {
		let sorted = [];
		scores.forEach(function (obj) {
			sorted.push(obj);
		})

		return sorted;
	}


	this.getMPI = function (clubId) {
		let mpi = 0;

		let totalScore = this.getTotalScore();

		this.matrix.forEach(function (iron) {
			if (iron.id == clubId) {
				let minDiff = Math.abs(totalScore - iron.min);
				let maxDiff = Math.abs(totalScore - iron.max);

				let diff = Math.min(minDiff, maxDiff);

				mpi = Math.round(98 - diff);
			}
		});

		return mpi
	}

	this.reset = function () {
		this.resetProgressBar()
		this.currentQuestion = 0
		this.intro.open()
		this.currentState = "intro"
		window.resizeFrame()
		this.scrollToTopOfPage()
	}


	this.scrollToTopOfPage = function () {
		try {
			window.scrollTo({
				top: 0,
				behavior: "auto"
			})
		} catch (e) {
			console.log("scroll to top error")
		}
		try {
			window.parent.postMessage(["scrollToTop"], "*")
		} catch (e) {
			console.log("scroll to top error")
		}
	}

	this.fillProgressBar = function () {
		//let direction = this.currentQuestion >= this.progressIndex ? 1 : -1
		if (this.currentQuestion > 0) {
			self.progressBar.show();
		}
		self.progressIndex = this.currentQuestion - 1;
		self.progressBar.setProgress(this.progressIndex, this.totalQuestions);
	}

	this.clearProgressBar = function (direction) {
		self.progressBar.setProgress(0, this.totalQuestions);
	}

	this.hideProgressBar = function () {
		self.progressBar.hide();
		self.progressBar.setProgress(0, this.totalQuestions);
	}

	this.completeProgressBar = function () {
		self.progressBar.setProgress(this.totalQuestions, this.totalQuestions);
	}

	this.resetProgressBar = function () {
		self.progressBarSegments.forEach(function (el) {
			el.classList.add("no-animate")
			el.clientHeight
			el.classList.remove("is-complete")
			el.classList.remove("is-active")
			el.clientHeight
			el.classList.remove("no-animate")
		})
		self.progressIndex = 0;
		self.progressBar.setProgress(this.progressIndex, this.totalQuestions);
	}

	this.getHeight = function () {
		let height = 800;
		let width = window.innerWidth;
		let body = document.body;
		let main = document.getElementById('main');

		height = main.clientHeight;

		return height
	}
}

export default Application
